// document ready
jQuery(document).ready(function ($) {

    // breakpoints
    let breakpoint = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200
    };

    // product get quick view data into model
    function product_load_quick_view(product_id) {

        // empty the modal of its previous contents
        $('.modal-body','#modal_quick_view').empty();

        // jquery ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action : 'product_quick_view',
                product_id  : product_id
            },
            success: function (data) {

                // load the data into modal
                $('.modal-body','#modal_quick_view').html(data);

                // load the quick view modal
                $('#modal_quick_view').modal('show').on('shown.bs.modal', function () {

                    // re init gallery
                    product_single_galleries();
                    tooltips();

                }).on('hide.bs.modal', function () {

                    // destroy the gallery
                    $OptionsGallerySlider.slick('unslick');
                    $OptionsGallerySliderNav.slick('unslick');
                    $ProductGallerySlider.slick('unslick');

                });

            }
        });

    }

    // launch quick view modal
    $('.quick-view','.product-item').on('click', function (e) {

        // get the current clicked item product id
        var product_id = $(this).closest('.product-item').data('id');

        // get product quick view article data
        product_load_quick_view(product_id);

        // prevent default
        e.preventDefault();

    });

    // product options gallery
    function product_single_galleries() {

        // our options product gallery
        let $OptionsGallery = $('.product-options-gallery');
        let $ProductGallery = $('.product-gallery');

        // all the slick sliders on the product page
        $OptionsGallerySlider       = $('.slider', $OptionsGallery);
        $OptionsGallerySliderNav    = $('.slider-nav', $OptionsGallery);
        $ProductGallerySlider       = $('.slider', $ProductGallery);

        // thumb count for option gallery nav slider
        var thumbsCount = $OptionsGallerySlider.data('thumbs');

        // product options gallery
        $OptionsGallerySlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            adaptiveHeight: true,
            asNavFor: '.product-options-gallery .slider-nav',
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="far fa-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="far fa-chevron-right"></i></button>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: breakpoint.lg,
                    settings: {
                        fade: true
                    }
                }
            ]
        });

        // product options gallery nav
        $OptionsGallerySliderNav.slick({
            slidesToShow: thumbsCount,
            dots: true,
            arrows: false,
            focusOnSelect: true,
            asNavFor: '.product-options-gallery .slider'
        });

        // product options gallery light box
        $OptionsGallerySlider.lightGallery({
            selector: '.lightgallery'
            //exThumbImage: 'data-thumbnail'
        });

        // product gallery slider
        $ProductGallerySlider.slick({
            slidesToShow: 1,
            dots: true,
            focusOnSelect: true,
            adaptiveHeight: true,
            arrows: true,
            infinite: false,
            prevArrow: '<button type="button" class="slick-prev"><i class="far fa-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="far fa-chevron-right"></i></button>'
        });

        // product gallery light box
        $ProductGallery.lightGallery({
            selector: '.lightgallery'
        });

    } product_single_galleries();


    // product archive row
    let $products = $('#product-archive > .row:first-child');


    // load more archive button
    $(document).on('click', '#products-load-more', function () {

        // our click button
        let $btn = $(this);

        // disable button
        $btn.html('<i class="fas fa-spinner fa-spin"></i> Loading products').prop('disabled', true);

        // set currents empty array
        let currentProducts = [];

        // loop thought trough all products in products in archive
        $('[data-id]', $products).each(function (key, el) {

            // current product push elem
            currentProducts.push($(el).data('id'));

        });

        // post current page again
        $.post('', {

            // pass this data
            excludeItems: currentProducts

        }, function (html) {

            // find all the products the parent div
            let $newProducts = $('#product-archive [data-id]', html).parent();

            // products append
            if ( $newProducts.length < PostsPerPage ) {

                // hide button
                $btn.hide();

            }

            // products append
            $products.append( $newProducts );

        })

        // products loaded
        .done(function() {

            // images loaded
            $('#product-archive').imagesLoaded()
                .progress( function(instance,image) {
                    $(image.img).addClass('img-loaded');
                });

            tooltips();

            // re-enable button
            $btn.html('<i class="fal fa-chevron-down"></i> Load more products').prop('disabled', false);

        });

    });

    // // load more archive button
    // $('#load_more_products').on('click', function () {
    //
    //     // our click button
    //     var $btn = $(this);
    //
    //     // disable button
    //     $btn.html('<i class="fas fa-spinner fa-spin"></i> Loading products').prop('disabled', true);
    //
    //     // set currents empty array
    //     var currentProducts = [];
    //
    //     // loop thought trough all products in products in archive
    //     $('[data-product]', $products).each(function (key, el) {
    //
    //         // current product push elem
    //         currentProducts.push($(el).data('product'));
    //
    //     });
    //
    //     // post current page again
    //     $.post('', {
    //
    //         // pass this data
    //         excludeItems: currentProducts
    //
    //     }, function (html) {
    //
    //         // find all the products the parent div
    //         var $newProducts = $('#product_archive [data-product]', html).parent();
    //
    //         //console.log($newProducts);
    //
    //         // products append
    //         if ( $newProducts.length < PostsPerPage ) {
    //
    //             // hide button
    //             $btn.hide();
    //
    //         }
    //
    //         // products append
    //         $products.append( $newProducts );
    //
    //     })
    //
    //         // products loaded
    //         .done(function() {
    //
    //             // load images on the
    //             var imgLoad = imagesLoaded('#product_archive');
    //             imgLoad.on( 'progress', function( instance, image ) {
    //                 $(image.img).parent('.img-thumbnail').addClass('img-loaded');
    //             }).on( 'done', function( instance ) {
    //                 setTimeout(function() {
    //                     //$('#product_archive').find('.img-thumbnail > I').remove();
    //                 }, 1000);
    //             });
    //
    //             // re-enable button
    //             $btn.html('<i class="far fa-arrow-alt-down"></i> Load more products').prop('disabled', false);
    //
    //         });
    //
    // });

    let $productItems;

    $(window).on('scroll', function (e) {

        // get the current last item
        $productItems = $('.product-item','#product-archive');

        // count our products

        //console.log($productItems.length);

    });


});